import * as TypeGraphQL from "type-graphql";
export var SignalQueueStatus;
(function (SignalQueueStatus) {
    SignalQueueStatus["QUEUED"] = "QUEUED";
    SignalQueueStatus["PROCESSING"] = "PROCESSING";
    SignalQueueStatus["COMPLETED"] = "COMPLETED";
    SignalQueueStatus["FILTERED"] = "FILTERED";
    SignalQueueStatus["EXPIRED"] = "EXPIRED";
})(SignalQueueStatus || (SignalQueueStatus = {}));
TypeGraphQL.registerEnumType(SignalQueueStatus, {
    name: "SignalQueueStatus",
    description: undefined,
});
//# sourceMappingURL=SignalQueueStatus.js.map